/**
 * External dependencies
 */

export default class Authentication {
  constructor(cscom) {
    if (!(this instanceof Authentication)) {
      return new Authentication(cscom);
    }
    this.cscom = cscom;
  }

  login(username, password) {
    return this.cscom.req.post("/api/rest/talink/authentication/login", null, {
      username,
      password,
    });
  }

  me() {
    return this.cscom.req.get("/api/rest/talink/authentication/me");
  }

  authenticate(body) {
    return this.cscom.req.post(
      "/api/rest/talink/authentication/authenticate",
      null,
      body,
    );
  }
}
